import { PureComponent } from 'react';

import { Typography } from 'omakase';

export default class EmptyState extends PureComponent {
  render() {
    return (
      <div className="EmptyState-container">
        <h1 className="EmptyState-title">
          {' '}
          <Typography component="span" variant="heading02">
            No results
          </Typography>{' '}
        </h1>
        <div className="EmptyState-optionDescription">
          <Typography variant="body02">Please adjust your search and try again.</Typography>
        </div>
      </div>
    );
  }
}
